export default "__VITE_ASSET__DhwxpQRh__"